/** technical username prefix of auto-generated guest accounts (`Gast_wacherHase451`) */
export const GUEST_NAME_PREFIX = 'Gast_';

/** anything that carries a player name (table member, online-list entry, chat message ...) */
export interface NamedPlayerLike {
  username?: string | null;
  isGuest?: boolean | null;
  premiumBadge?: boolean | null;
}

/**
 * true if the player is a guest account.
 *
 * The backend delivers `isGuest: true` for guests and OMITS the flag for registered
 * users (like `premiumBadge`), so `isGuest` is either `true` or `undefined`.
 * FALLBACK: when the payload does not carry the flag at all (older backend, or a
 * payload that has not been extended yet) a name starting with `Gast_` is treated
 * as a guest — registered users cannot pick that prefix.
 * An explicit `isGuest: false` always wins over the name.
 */
export function isGuestPlayer(player: NamedPlayerLike | null | undefined): boolean {
  if (!player) return false;
  if (player.isGuest === true) return true;
  if (player.isGuest === false) return false;
  return (player.username || '').startsWith(GUEST_NAME_PREFIX);
}

/**
 * name to show for a player: guests lose the technical `Gast_` prefix (they get a
 * separate "Gast" tag instead). The prefix is only stripped for guests AND only when
 * the name really starts with it.
 */
export function displayPlayerName(player: NamedPlayerLike | null | undefined): string {
  const username = player?.username || '';
  if (isGuestPlayer(player) && username.startsWith(GUEST_NAME_PREFIX)) {
    return username.slice(GUEST_NAME_PREFIX.length) || username;
  }
  return username;
}

/** plain-text label for titles / tooltips / aria: `wacherHase451 (Gast)` */
export function playerNameLabel(player: NamedPlayerLike | null | undefined): string {
  const name = displayPlayerName(player);
  return isGuestPlayer(player) ? `${name} (Gast)` : name;
}
